import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useUsersService } from '../../../../apis/users/useUsersService';
import { TUsersByCategoryResponse } from '../../../../apis/users/users.api.interfaces';
import { UserCategory } from '../users.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getUsersByCategoryKey = 'get-users-by-category';

export const useUsersByCategoryHook = (
  category: UserCategory,
  page: number = 1,
  limit: number = 10,
  search?: string,
): UseQueryResult<TUsersByCategoryResponse, TQueryError> => {
  const { getUsersByCategory } = useUsersService();

  return useQuery<TUsersByCategoryResponse, TQueryError>({
    queryKey: [getUsersByCategoryKey, category, page, limit, search],
    queryFn: () => getUsersByCategory({ category, page, limit, search }),
    enabled: !!category,
  });
};
